import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../action/logout-action';

interface LanguageInfoState {
  languageForms: Array<{
    id: string;
    language: {
      id: string;
      name: string;
    };
    proficiencylevel: {
      level: string;
    };
  }>;
}

const initialState: LanguageInfoState = {
  languageForms: [],
};

const languageInfoSlice = createSlice({
  name: 'languageInfo',
  initialState,
  reducers: {
    setLanguageInfo: (state, action: PayloadAction<LanguageInfoState>) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setLanguageInfo } = languageInfoSlice.actions;
export default languageInfoSlice.reducer; 